import { render, staticRenderFns } from "./NewRate.vue?vue&type=template&id=5ea2073a"
import script from "./NewRate.vue?vue&type=script&lang=js"
export * from "./NewRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports